module.exports = function getResource(label) {
    let resources = {
        removePhoto: 'Retirer la photo',
        addPhoto: 'Ajouter une photo'
    };
    return resources[label];
};
